import React from "react";
import { Images, RecommendsStaticData } from "../../utils/constant";
import "./style.css";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Heading from "../common/heading";
import SubHeading from "../common/subheading";
import { applyHoverAnimation } from "../../utils/animation";
import { useDeviceType } from "../../utils/isMobileHook";

gsap.registerPlugin(SplitText, ScrollTrigger, useGSAP);

const Recommends = () => {
  const sectionRef = React.useRef<HTMLDivElement>(null);
  const contentContainerRef = React.useRef<HTMLDivElement>(null);
  const mobileImageRef = React.useRef<HTMLImageElement>(null);
  const cardContainerRef = React.useRef<HTMLDivElement>(null);
  const cardsRef = React.useRef<HTMLDivElement[]>([]);
  const floatingTween = React.useRef<gsap.core.Tween | null>(null);
  const { isMobile } = useDeviceType();

  useGSAP(
    () => {
      gsap.from(mobileImageRef.current, {
        scrollTrigger: {
          trigger: mobileImageRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
        },
        autoAlpha: 0,
        duration: 2,
        x: -100,
        ease: "power3.out",
        onComplete: () => {
          floatingTween.current = gsap.to(mobileImageRef.current, {
            y: -25,
            duration: 1.5,
            ease: "power1.inOut",
            yoyo: true,
            repeat: -1,
          });

          // ✅ Safe: apply hover after floating is created
          applyHoverAnimation("#recommends-mobiles", floatingTween);
        },
      });

      gsap.from(cardsRef.current, {
        scrollTrigger: {
          trigger: cardContainerRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
        },
        x: 100,
        autoAlpha: 0,
        duration: 2,
        ease: "power3.out",
        stagger: 0.5,
      });
    },
    { scope: sectionRef }
  );

  return (
    <section
      style={{
        backgroundImage: `linear-gradient(#0d2647cc, #0d2647cc), url(${Images.recommendsBg})`,
      }}
      className="common-section-container"
      id="about-us"
    >
      <header className="common-heading-container overflow-hidden ">
        <Heading heading={RecommendsStaticData.recommendsHeading} />
        <SubHeading subheading={RecommendsStaticData.recommendsSubHeading} />
      </header>

      <div
        ref={(el) => {
          if (el) contentContainerRef.current = el;
        }}
        className="recommends-content-container"
      >
        <div className="recommends-left">
          <img
            src={Images.dotImage}
            alt="dots"
            className="recommends-dot-image"
          />
          <img
            ref={(el) => {
              if (el) mobileImageRef.current = el;
            }}
            src={Images.recommendsMobiles}
            alt="mobiles screen shot"
            className="recommends-left-image"
            id="recommends-mobiles"
          />
          <img
            src={Images.boxImage}
            alt="box"
            className="recommends-grey-box"
          />
        </div>
        <div
          ref={(el) => {
            if (el) {
              cardContainerRef.current = el;
            }
          }}
          className="recommends-cards-container"
        >
          {RecommendsStaticData.cards.map((card, index) => {
            return (
              <div
                key={index}
                className="recommends-card overflow-hidden"
                ref={(el) => {
                  if (el) {
                    cardsRef.current[index] = el;
                  }
                }}
              >
                <figure className="recommends-card-image-container">
                  <img
                    src={card.image}
                    alt={card.heading}
                    className="recommends-card-image"
                  />
                </figure>
                <div className="recommends-card-content">
                  <h5 className="recommends-card-heading">{card.heading}</h5>
                  <p className="recommends-card-subheading">
                    {card.subheading(isMobile)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Recommends;
